"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shortcut_plugin_1 = require("./shortcut-plugin");
function controllerShortcut(regexp, name, config) {
    return new shortcut_plugin_1.TextShortcut(name, regexp, function (view, state, match, start, end) {
        if (config.handler) {
            config.handler(match, start, {
                getStart: function () { return view.coordsAtPos(start); },
                getEnd: function () { return view.coordsAtPos(end); }
            });
        }
        return null;
    }, config);
}
exports.controllerShortcut = controllerShortcut;
//# sourceMappingURL=controller-shortcut.js.map